import {ChangeDetectorRef, Component, OnInit} from '@angular/core'
import {Card, LaunchDialogService} from '@spartacus/storefront'
import {BehaviorSubject, Subscription} from 'rxjs'
import {EbAddress} from "../../../interface/eb-checkout.interface"
import {EbCheckoutDeliveryService} from "../../../services/facades/eb-checkout-delivery.service";

@Component({
    selector: 'eb-shipping-address-delete-modal',
    templateUrl: './eb-shipping-address-delete-modal.component.html',
    styleUrls: ['./eb-shipping-address-delete-modal.component.scss'],
    standalone: false
})
export class EbShippingAddressDeleteModalComponent implements OnInit {
  submitting$: BehaviorSubject<false>
  address: EbAddress
  selectedAddressSubscription: Subscription
  constructor(
    protected modalService: LaunchDialogService,
    protected cd: ChangeDetectorRef,
    protected ebCheckoutDeliveryService: EbCheckoutDeliveryService,
  ) {
  }

  ngOnInit(): void {
    this.modalService.data$.subscribe(dialogData => {
      this.address = dialogData.address
      this.submitting$ = dialogData.submitting$
    })
  }

  dismissModal(reason?: any): void {
    this.modalService.closeDialog(reason)
  }

  deleteAddress() {
    this.ebCheckoutDeliveryService.submitDeleteAddress(this.address.id)
      .subscribe( () =>{
        this.submitting$.next(false)
        this.dismissModal('New shipping address created')
    })
  }
  getCardContent(): Card {
    return {
      title: this.address.companyName ? this.address.companyName : '',
      text: [
        `${this.address.line1} ${this.address.line2}`,
        `${this.address.postalCode} ${this.address.town}`,
        this.address.country?.name || this.address.country?.isocode,
        this.address.name3 ? '' : undefined,
        this.address.name3
      ],
      customClass: 'no-action-card'
    }
  }

  ngOnDestroy(): void {
    this.selectedAddressSubscription?.unsubscribe()
  }
}
